export const getFilterSaleType = state => state.saleType.filter
